import { render, staticRenderFns } from "./TaskCreationDialog.vue?vue&type=template&id=1e4dfd9a&scoped=true"
import script from "./TaskCreationDialog.vue?vue&type=script&lang=js"
export * from "./TaskCreationDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskCreationDialog.vue?vue&type=style&index=0&id=1e4dfd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4dfd9a",
  null
  
)

export default component.exports